import React from 'react';
import { Control } from 'react-hook-form';
import { ControllerWrapper } from '../../../../../../hooks/providers/ControllerWrapper';
import { InviteFlowFields } from '../../../../consts';
import { LiliTextInput } from '../../../../../../DesignSystem/LiliTextInput/LiliTextInput';

import { InviteFormType } from '../../InviteFormStep';

interface FirstNameInputProps {
  control: Control<InviteFormType, any>;
  title: string;
}

const MAX_EMAIL_CHARACTERS = 250;
export const EmailNameInput = ({ control, title }: FirstNameInputProps) => (
  <ControllerWrapper name={InviteFlowFields.EMAIL} control={control}>
    {({ onBlur, onChange, error, value }) => (
      <LiliTextInput
        onChange={(val) => onChange(val.trim())}
        value={value}
        onBlur={onBlur}
        id={InviteFlowFields.EMAIL}
        title={title}
        errorMessage={error?.message}
        maxLength={MAX_EMAIL_CHARACTERS}
      />
    )}
  </ControllerWrapper>
);
